import { FC } from 'react'
import clsx from 'clsx'
import styles from './ConteudoNotaVersao.module.css'
import { sanitizarNotaVersao } from './sanitizarNotaVersao'

type Props = {
  conteudo: string
  /** Nome acessível da região rolável. */
  ariaLabel: string
  className?: string
}

/**
 * Único ponto de renderização do HTML de uma nota de versão (modal, histórico e pré-visualização).
 * O backend não sanitiza: o conteúdo de SUPER_ADMIN é exibido a todos os tenants. Imagem só da própria API
 * (ver `sanitizarNotaVersao`).
 */
export const ConteudoNotaVersao: FC<Props> = ({ conteudo, ariaLabel, className }) => (
  <div
    className={clsx(styles.conteudo, className)}
    tabIndex={0}
    role='region'
    aria-label={ariaLabel}
    dangerouslySetInnerHTML={{ __html: sanitizarNotaVersao(conteudo) }}
  />
)
